import { Col, Row, Select, SelectProps, Space, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { makeRequest } from '../../../../helpers/axios-manipulator';
const { Text, Title } = Typography;

type Props = {
  setData: Function,
  data: any,
}

type FilterType = "artist" | "artwork" | "placard";
const optionFilterPropValues = {
  "artist": "artistValue",
  "artwork": "label",
  "placard": "placardValue",
}

const ArtworkSelect = ({ setData, data }: Props) => {
  const [filterType, setFilterType] = useState("artwork");
  const [options, setOptions] = useState<SelectProps['options']>()

  useEffect(() => {
    const fetchBusinessEvents = async () => {
      try {
        const response = await makeRequest({
          origin: window.location.origin,
          method: 'get',
          url: `/api-artworks`,
          headers: {},
        });
        let opts = [] as SelectProps['options'];
        await response.map((r: any) => {
          return opts?.push(
            {
              label: r.title,
              value: r.id,
              artistValue: r.artist_name,
              placardValue: r.code,
              emoji: r.image_url,
              desc: r.title,
            },
          )
        })
        setOptions(opts)
      } catch (error) {
        console.error('Error fetching business events:', error);
      }
    };

    fetchBusinessEvents();
  }, []);
  const handleChange = (value: string[]) => {
    setData({ ...data, artworks: value })
  };
  return (
    <Row gutter={8}>
      <Col className='mb-2' span={24} md={8}>
        <Text>Search by</Text>
        <Select
          value={filterType}
          placeholder="All"
          onChange={(e) => setFilterType(e)}
          style={{ width: '100%' }}
          options={[
            { value: 'artist', label: 'Artist' },
            { value: 'artwork', label: 'Artwork' },
            { value: 'placard', label: 'Placard' },
          ]}
        />
      </Col>
      <Col className='mb-2' span={24} md={16}>
        <Text>{filterType}</Text>
        <Select
          mode="multiple"
          loading={options?.length === 0}
          style={{ width: '100%' }}
          placeholder="select one artwork"
          optionFilterProp={optionFilterPropValues[filterType as unknown as FilterType]}
          onChange={handleChange}
          optionLabelProp="label"
          value={data.artworks}
          options={options}
          optionRender={(option) => (
            <Space    >
              <span>{option.data.title}</span>
              <img style={{ objectFit: 'cover' }} width={50} height={50}
                src={option.data.emoji} alt={option.data.title}
              />
              {option.data.desc}
            </Space>
          )}
        />
      </Col>
    </Row>
  )
}

export default ArtworkSelect